<template>
  <div>
    <v-dialog scrollable v-model="model" persistent max-width="600px">
      <material-card
        v-if="editedItem !== null && editedItem !== undefined"
        :title="
          $t(
            'components.employers.employer_logo_dialog.choose_employer_{0}_logo',
            [trans(editedItem, 'Name')]
          )
        "
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-row>
              <v-col xs="12" sm="6" md="4" lg="4">
                <pbas-date-picker
                  :value="effectiveDate"
                  @update-date="effectiveDate = $event"
                  :label="$t('globals.effective_date')"
                  :rules="[$rules.required, $rules.firstRenewalDate]"
                  :allowedDates="allowedDates"
                  class="required"
                ></pbas-date-picker>
              </v-col>
              <v-col v-if="effectiveDate">
                <image-uploader-string
                  @image-data="
                    editedItem.Current.LogoBase64 = $event;
                    $forceUpdate();
                  "
                  :image.sync="editedItem.Current.LogoBase64"
                  :label="$t('globals.logo')"
                  :rules="[$rules.required]"
                ></image-uploader-string>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="saving"
            text
            @click="
              unlock();
              editedItem = null;
              effectiveDate = null;
              $emit('close');
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="saving"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { locker } from "@/mixins/locker";
import { translate2 } from "@/trans2";
import ImageUploaderString from "@/components/ImageUploaderString";

export default {
  components: {
    ErrorHandler,
    ImageUploaderString,
  },
  mixins: [locker],
  props: ["model", "id"],
  data() {
    return {
      error: null,
      saving: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      editedItem: null,
      valid: false,
      effectiveDate: null,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planOptions", "planIdentity"]),
    ...mapGetters("common", ["language"]),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadItem();
        }
      },
    },
    effectiveDate: {
      handler(v) {
        if (v) {
          if (this.isNew) {
            this.editedItem = {};
          } else {
            this.loadItem(v);
          }
        }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", ["getEmployerForLogo", "updateEmployerLogo"]),
    allowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    async loadItem() {
      try {
        if (this.lockId) {
          this.editedItem = await this.getEmployerForLogo({
            planIdentityId: this.selectedPlan.Id,
            employerId: this.id,
          }).data;
        } else {
          this.editedItem = await this.lock(
            this.getEmployerForLogo,
            {
              planIdentityId: this.selectedPlan.Id,
              employerId: this.id,
            },
            () => {}
          );
        }
      } catch (error) {
        this.error = error;
      }
    },
    async save() {
      this.saving = true;
      try {
        await this.updateEmployerLogo({
          planIdentityId: this.selectedPlan.Id,
          employerId: this.id,
          payload: {
            LogoBase64: this.editedItem.Current.LogoBase64,
            EffectiveDate: this.effectiveDate,
          },
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;

        if (this.$refs.infoForm) this.$refs.infoForm.resetValidation();
        if (this.$refs.detailsForm) this.$refs.detailsForm.resetValidation();

        this.editedItem = null;
        this.effectiveDate = null;
        this.unlock();
        this.$emit("close");
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    trans(item, field) {
      return translate2(item, field);
    },
  },
};
</script>
